import React from 'react';
import { FileText, Zap, BookOpen, ShieldCheck, Lock, CreditCard, Star } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#1B4D2E] text-white pb-16 px-4 relative overflow-hidden" data-id="element-118">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-119">
        {/* Above-the-fold block: fits a single iPhone viewport from top through the first CTA */}
        <div className="flex flex-col justify-center items-center min-h-[100svh] py-4 md:min-h-0 md:py-16" data-id="element-120">
          <div className="inline-block bg-white/10 text-white border border-white/20 rounded-full px-4 py-1.5 text-xs md:text-sm font-semibold tracking-wide mb-3 md:mb-6 uppercase" data-id="element-121">
            ENTRENADOR LISTO · RUGBY 360
          </div>

          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-3 md:mb-6" data-id="element-122">
            Todo tu año de rugby resuelto de una vez.
          </h1>

          <div className="mb-3 md:mb-6" data-id="element-123">
            <img src="https://cdn.magicpatterns.com/uploads/mdZnhfRPLiiFAndQv7B4yz/MOCKUP_RUGBY.png" alt="Megapack Rugby 360 — Pack Anual Élite Completo con 14 Tomos, 6 Bonos y 2 Ebooks Élite" width={512} height={512} fetchPriority="high" decoding="async" className="w-full max-w-[260px] sm:max-w-xs md:max-w-lg mx-auto max-h-[32vh] md:max-h-none object-contain drop-shadow-2xl" data-id="element-124" />
          </div>

          <h2 className="text-[#FFD700] text-lg sm:text-xl md:text-3xl font-bold mb-2 md:mb-6" data-id="element-125">
            Megapack RUGBY 360 — Pack Anual Élite Completo
          </h2>

          <p className="text-sm sm:text-base md:text-xl text-gray-200 mb-4 md:mb-8 max-w-2xl mx-auto" data-id="element-126">
            El sistema completo de planificación y sesiones listas para el
            entrenador de rugby argentino
          </p>

          <div className="flex flex-wrap justify-center gap-3 md:gap-8 text-xs sm:text-sm md:text-base font-medium mb-5 md:mb-10" data-id="element-127">
            <div className="flex items-center gap-2" data-id="element-128">
              <FileText className="text-[#FFD700]" size={18} data-id="element-129" />
              <span data-id="element-130">PDF</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-131">
              <Zap className="text-[#FFD700]" size={18} data-id="element-132" />
              <span data-id="element-133">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-134">
              <BookOpen className="text-[#FFD700]" size={18} data-id="element-135" />
              <span data-id="element-136">14 Tomos + 6 Bonos + 2 Élite</span>
            </div>
          </div>

          <button onClick={scrollToPricing} className="bg-[#84CC16] hover:bg-[#65A30D] text-white text-lg md:text-2xl font-bold py-4 md:py-5 px-8 rounded-xl shadow-[0_0_30px_rgba(132,204,22,0.4)] transition-all transform hover:scale-105 w-full md:w-auto" data-id="element-137">
            💪 QUIERO MI RUGBY 360 AHORA
          </button>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-xs md:text-sm text-gray-300 mb-12 pt-12" data-id="element-138">
          <div className="flex items-center gap-1" data-id="element-139">
            <ShieldCheck size={16} data-id="element-140" />
            <span data-id="element-141">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-142">
            <Lock size={16} data-id="element-143" />
            <span data-id="element-144">Pago seguro</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-145">
            <CreditCard size={16} data-id="element-146" />
            <span data-id="element-147">Tarjetas y transferencia</span>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 border-t border-white/20 pt-10" data-id="element-148">
          <div data-id="element-149">
            <div className="text-3xl font-bold text-white mb-1" data-id="element-150">+200</div>
            <div className="text-sm text-gray-300" data-id="element-151">entrenadores confían</div>
          </div>
          <div data-id="element-152">
            <div className="text-3xl font-bold text-white mb-1" data-id="element-153">14+6</div>
            <div className="text-sm text-gray-300" data-id="element-154">Tomos + Bonos</div>
          </div>
          <div data-id="element-155">
            <div className="text-3xl font-bold text-white mb-1" data-id="element-156">4.9/5</div>
            <div className="text-sm text-gray-300" data-id="element-157">calificación</div>
          </div>
          <div data-id="element-158">
            <div className="text-3xl font-bold text-white mb-1 flex justify-center items-center gap-2" data-id="element-159">
              <Star className="fill-[#FFD700] text-[#FFD700]" size={24} data-id="element-160" />
            </div>
            <div className="text-sm text-gray-300" data-id="element-161">🇦🇷 Argentina</div>
          </div>
        </div>
      </div>
    </section>;
}